var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCoin = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#coin_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M14.285 7.664A5.72 5.72 0 0 1 20 13.38a5.72 5.72 0 0 1-5.715 5.715 5.7 5.7 0 0 1-3.85-1.495c-.49-.447-.9-.978-1.211-1.569a5.7 5.7 0 0 1-.654-2.651q0-.553.102-1.076a5.726 5.726 0 0 1 5.613-4.639M0 14.525q.39.264.853.495c1.568.785 3.633 1.217 5.813 1.217q.277 0 .552-.01a7.6 7.6 0 0 0 1.05 1.823 14 14 0 0 1-1.602.092c-3.815 0-6.665-1.508-6.666-2.857zm0-3.81q.39.264.853.497c1.568.784 3.633 1.216 5.813 1.216l.059-.001a7.7 7.7 0 0 0 0 1.905h-.059C2.851 14.332 0 12.824 0 11.476zm0-3.809q.39.264.853.496c1.568.785 3.633 1.216 5.813 1.216.595 0 1.182-.033 1.752-.096a7.6 7.6 0 0 0-1.192 1.99q-.276.01-.56.01C2.851 10.523 0 9.016 0 7.667zM6.666 1c3.815 0 6.667 1.508 6.667 2.856 0 1.35-2.852 2.858-6.667 2.858S0 5.205 0 3.856C0 2.508 2.85 1 6.666 1"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "coin_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h20v20H0z"
})))));
export default SvgCoin;